import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { MaxTimeoutMs } from '~/constants/api'
import { getAccessToken } from '~/api/client/oidcClient'

export const apiClient: AxiosInstance = axios.create({
  timeout: MaxTimeoutMs,
  baseURL: import.meta.env.VITE_AUNIVERS_API_URL,
  headers: {
    'Content-Type': 'application/ld+json',
    'Accept': 'application/ld+json',
  },
  transformRequest: [(data, headers) => {
    headers['Authorization'] = `Bearer ${getAccessToken()}`
    return JSON.stringify(data)
  }],
})
